import mergeJsonSchemas from "merge-json-schemas";
import { SUPPORTED_COUNTRIES } from "../constants";
import { BILLING_INFO_FORM_SCHEMA } from "./billingInformationFormSchema";
import { getFieldTemplate, getSubmitTemplate } from "./schemaUtil";

const generateBankAccountSchema = (country) => {
	const commonFieldsSchema = {
		type: "object",
		required: ["accountNumber", "name"],
		properties: {
			accountNumber: { ...getFieldTemplate("Account Number") },
			bankAccountType: { ...getFieldTemplate("Bank Account Type") }
		}
	};
	if (country === SUPPORTED_COUNTRIES.CA) {
		return {
			...commonFieldsSchema,
			required: [...commonFieldsSchema.required, "transitNumber", "institutionNumber"],
			properties: {
				...commonFieldsSchema.properties,
				transitNumber: {
					...getFieldTemplate("Transit Number"),
					pattern: "^[0-9]{5}$"
				},
				institutionNumber: {
					...getFieldTemplate("Institution Number"),
					pattern: "^[0-9]{3}$"
				}
			}
		};
	}
	return {
		...commonFieldsSchema,
		required: [...commonFieldsSchema.required, "routingNumber"],
		properties: {
			...commonFieldsSchema.properties,
			routingNumber: { ...getFieldTemplate("Routing Number") }
		}
	};
};

const generateBankAccountFormSchema = (country) => {
	const bankAccountSchema = generateBankAccountSchema(country);
	const fieldsSchema = mergeJsonSchemas([
		{
			type: "object",
			required: bankAccountSchema.required,
			properties: bankAccountSchema.properties
		},
		BILLING_INFO_FORM_SCHEMA
	]);

	return Object.freeze({
		type: "object",
		title: "Bank Information",
		required: ["submitButton", "fields"],
		properties: {
			submitButton: { ...getSubmitTemplate() },
			fields: fieldsSchema
		}
	});
};
export { generateBankAccountFormSchema };
